/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import login from '@/views/login/login'
import layout from '@/views/layout/layout'
import overview from '@/views/data/overview'
import organization from '@/views/organization/organization'
import project from '@/views/project/project'
import student from '@/views/student/student'
import user from '@/views/user/user'

import {
  getCookie,
  removeCookie
} from '../util/utils'

Vue.use(Router)

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

let isdev = true // 权限参数

const router = new Router({
  mode: 'history',
  routes: [{
    path: '/login',
    name: 'login',
    title: '登录',
    component: login
  }, {
    path: '/',
    name: 'layout',
    title: '首页',
    redirect: {
      path: '/overview'
    },
    component: layout,
    children: [{
      path: '/overview',
      name: 'overview',
      title: '数据中心',
      component: overview,
      meta: {
        require: isdev
      }
    }, {
      path: '/organization',
      name: 'organization',
      title: '组织机构',
      component: organization,
      meta: {
        require: isdev
      }
    }, {
      path: '/project',
      name: 'project',
      title: '项目中心',
      component: project,
      meta: {
        require: isdev
      }
    }, {
      path: '/student',
      name: 'student',
      title: '学生维度',
      component: student,
      meta: {
        require: isdev
      }
    }, {
      path: '/user',
      name: 'user',
      title: '账号管理',
      component: user,
      meta: {
        require: isdev
      }
    }, {
      path: '/unit_dimension',
      name: 'unit_dimension',
      title: '单位维度',
      component: () => import('@/views/dimension/unit')
    }, {
      path: '/school_dimension',
      name: 'school_dimension',
      title: '学校维度',
      component: () => import('@/views/dimension/school')
    }, {
      path: '/teamVillage/topTeam',
      name: '/teamVillage_topTeam',
      title: '三下乡团队',
      component: () => import('@/views/teamVillage/topTeam')
    }, {
      path: '/teamVillage/teamManage',
      name: '/teamVillage_teamManage',
      title: '“揭榜”攻关团队数据',
      component: () => import('@/views/teamVillage/teamManage')
    }, {
      path: '/teamVillage/teamReport',
      name: '/teamVillage_teamReport',
      title: '团队报备数据',
      component: () => import('@/views/teamVillage/teamReport')
    }, {
      path: '/teamVillage/activityTeam',
      name: '/teamVillage_activityTeam',
      title: '专项活动团队数据',
      component: () => import('@/views/teamVillage/activityTeam')
    }]
  }]
})

// 路由守卫
router.beforeEach((to, from, next) => {

  let vue = new Vue()

  let token = getCookie('pd_token') // 获取缓存中的token

  if (to.matched.some(res => res.meta.require)) {

    if (to.name === 'login') {

      removeCookie('pd_token') // 清除token

      next()

    }

    if (token && token !== undefined) {

      next()

    } else {

      next({

        path: '/login'

      })

    }

  } else {

    next()

  }

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js